// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2e-Yf","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__7U2HH"};